import { ItemList } from '../../orm'

class AdminHylafaxIncomingFaxList extends ItemList {
    getEntityKey() {
        return "hylafax/incoming_fax"
    }
}

export const adminHylafaxIncomingFaxList = new AdminHylafaxIncomingFaxList("admin_hylafax_incoming_faxes__default")
